import { createSlice } from '@reduxjs/toolkit';


export type whatsNewState = {
  deletePopupVisible: boolean,
  deleteTitle: string,  
  deleteId: number,
}

export const initialStateWhatsNew: whatsNewState = {
  deletePopupVisible: false,
  deleteTitle: "",  
  deleteId: 0
};

export const whatsNewSlice = createSlice({
  name: 'whatsNew',
  initialState: initialStateWhatsNew,
  reducers: {
    toggleDeletePopupWhatsNew: (state) => {
      state.deletePopupVisible = !Boolean(state.deletePopupVisible)
    },
    setDeleteTitleAndIdWhatsNew: (state, action) => {
        state.deleteTitle = action.payload.title;        
        state.deleteId = action.payload.id;
    }
  }
});

export const { toggleDeletePopupWhatsNew, setDeleteTitleAndIdWhatsNew } = whatsNewSlice.actions;

export default whatsNewSlice.reducer;
